import React from "react";
import FlashChatWorkspace from "../Components/chat/FlashChatWorkspace";
import styles from "../Components/chat/ChatWorkspace.module.scss";

export default function AIChatPage() {
  return (
    <div className={styles.aiPageMain}>
      <FlashChatWorkspace fullScreen={true} enterpriseLayout={true} />
    </div>
  );
}
